import { Action } from 'redux';
import { isAction } from '../utils';

const SET_ROWS_PER_PAGE = 'PREFERENCES.SET_ROWS_PER_PAGE';

export interface SetRowsPerPage extends Action {
  rowsPerPage: number;
  type: typeof SET_ROWS_PER_PAGE;
}

export function setRowsPerPage(rowsPerPage: number) {
  return {
    rowsPerPage,
    type: SET_ROWS_PER_PAGE
  };
}
export const isSetRowsPerPage = isAction<SetRowsPerPage>(SET_ROWS_PER_PAGE);
